import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/hosting/vps-cloud")({
  component: () => <Outlet />,
});
